import React from "react";
import FilaPago from "./FilaPago";

const TablaPagos = ({ pagos, permiso, editPago, cancelPago }) => {
  function renderPagos(pagos) {
    if (pagos && pagos !== null) {
      return pagos.map((pago, index) => (
        <FilaPago
          pago={pago}
          index={index}
          key={pago.idPago}
          permiso={permiso}
          editPago={editPago}
          cancelPago={cancelPago}
        />
      ));
    }
  }

  return (
    <div className="table-responsive">
      <table className="table border">
        <thead>
          <tr className="bg-light bold">
            <th>#</th>
            <th>Concepto</th>
            <th>Monto</th>
            <th>Amortizado</th>
            <th>Autorizado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>{renderPagos(pagos)}</tbody>
      </table>
    </div>
  );
};

export default TablaPagos;
